import { render, staticRenderFns } from "./discuss.vue?vue&type=template&id=737a6b44&scoped=true"
import script from "./discuss.vue?vue&type=script&lang=js"
export * from "./discuss.vue?vue&type=script&lang=js"
import style0 from "./discuss.vue?vue&type=style&index=0&id=737a6b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737a6b44",
  null
  
)

export default component.exports